module.exports = __webpack_public_path__ + "img/ring_y_i_null_null@2x.affb3846.png";